import { atomWithStorage } from "jotai/utils"

export type AuthUser = {
  id: number
  name: string
  username: string
  email: string
  role: string
  purchasedCourses: number[]
  returning: boolean
  firstName?: string
  lastName?: string
}

export function profileNames(user: AuthUser | null | undefined) {
  const firstName = typeof user?.firstName === "string" ? user.firstName.trim() : ""
  const lastName = typeof user?.lastName === "string" ? user.lastName.trim() : ""
  return { firstName, lastName }
}

export function isProfileComplete(user: AuthUser | null | undefined) {
  const { firstName, lastName } = profileNames(user)
  return Boolean(firstName && lastName)
}

export function userInitials(user: AuthUser | null | undefined) {
  const { firstName, lastName } = profileNames(user)
  if (!firstName || !lastName) return ""
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
}

export const userAtom = atomWithStorage<AuthUser | null>("liosh-user", null, undefined, {
  getOnInit: true,
})

export const tokenAtom = atomWithStorage<string | null>("liosh-token", null, undefined, {
  getOnInit: true,
})
